import { AsyncStatus, defaultInitialState, State } from 'hooks/useAsync';
import AttioService, { AttioVerifyIntegrationResult } from './AttioService';
import { useCallback, useState } from 'react';

const useVerifyAttioIntegration = () => {
  const [{ error, isLoading, data, status }, setState] =
    useState<State<AttioVerifyIntegrationResult>>(defaultInitialState);

  const verifyAttioIntegration = useCallback(async () => {
    setState({
      error: null,
      status: AsyncStatus.pending,
      data: null,
      isLoading: true,
    });
    const resultPromise = AttioService.verifyAttioIntegration();
    resultPromise.then(
      (result) => {
        setState({
          error: null,
          status: AsyncStatus.resolved,
          data: result,
          isLoading: false,
        });
      },
      (error) => {
        setState({
          error: error,
          status: AsyncStatus.rejected,
          data: null,
          isLoading: false,
        });
      },
    );
  }, [setState]);

  return {
    verifyAttioIntegration,
    error,
    isLoading,
    isError:
      status === AsyncStatus.rejected ||
      (data?.data ? !data?.data.isSuccess : false),
    isSuccess: status === AsyncStatus.resolved && data?.data.isSuccess,
    data,
  };
};

export default useVerifyAttioIntegration;
